import { obtenirUrlControleur } from '../utils/urlUtils';
import { rafraichirAccessToken } from '../utils/auth';
import { ReponseMembreDto } from '../modeles/ReponseMembreDto';
import { ModifierRoleMembreRequest } from '../modeles/ModifierRoleMembreRequest';

const lienMembre = obtenirUrlControleur('membre');

function obtenirHeadersAuthentifies(token?: string): HeadersInit {
  const accessToken = token || localStorage.getItem('accessToken');

  return {
    accept: 'application/json',
    'content-type': 'application/json',
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
}

async function lireErreur(reponse: Response): Promise<string> {
  try {
    const data = await reponse.json();
    return data?.message || 'Erreur serveur';
  } catch (error) {
    return 'Erreur serveur';
  }
}

async function requeteAvecRafraichissement(requeteFn: (headers: HeadersInit) => Promise<Response>): Promise<Response> {
  let reponse = await requeteFn(obtenirHeadersAuthentifies());

  if (reponse.status === 401) {
    const nouveauToken = await rafraichirAccessToken();
    if (!nouveauToken) {
      throw new Error('Session expirée. Veuillez vous reconnecter.');
    }
    reponse = await requeteFn(obtenirHeadersAuthentifies(nouveauToken));
  }

  return reponse;
}

export default class GestionDroitsPilotageApi {
  static async listerMembres(): Promise<ReponseMembreDto[]> {
    const reponse = await requeteAvecRafraichissement((headers) =>
      window.fetch(`${lienMembre}/api/membre/membres/droits-pilotage`, {
        method: 'GET',
        headers,
      })
    );

    if (!reponse.ok) {
      throw new Error(await lireErreur(reponse));
    }

    return reponse.json() as Promise<ReponseMembreDto[]>;
  }

  static async modifierRolePilotage(id: string, rolePilotage: string): Promise<void> {
    const request: ModifierRoleMembreRequest = { rolePilotage };
    const reponse = await requeteAvecRafraichissement((headers) =>
      window.fetch(`${lienMembre}/api/membre/membres/${id}/droits-pilotage`, {
        method: 'PUT',
        headers,
        body: JSON.stringify(request),
      })
    );

    if (!reponse.ok) {
      throw new Error(await lireErreur(reponse));
    }
  }
}
